import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import feedReducer from "./reducers";

const initialState = {};
const middleware = [thunk];
const store = createStore(
  feedReducer,
  initialState,
  compose(
    applyMiddleware(...middleware)
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

export default store;
